// Enhancer für zoombare Bilder: Klick auf a[data-lightbox-group] öffnet die
// Lightbox mit allen Bildern derselben Gruppe. Die Vue-App lebt nur solange
// das Overlay offen ist — das server-gerenderte Markup bleibt unangetastet.
import { createApp } from 'vue'
import Lightbox from './components/Lightbox.vue'

export function initLightbox(root = document) {
	root.querySelectorAll('a[data-lightbox-group]').forEach((link) => {
		if (link._lightboxBound) return
		link._lightboxBound = true
		link.addEventListener('click', (e) => {
			e.preventDefault()
			const group = link.getAttribute('data-lightbox-group')
			const links = Array.from(
				document.querySelectorAll(`a[data-lightbox-group="${CSS.escape(group)}"]`)
			)
			const images = links.map((a) => ({
				src: a.getAttribute('data-lightbox-src') || a.href,
				caption: a.getAttribute('data-alt') || '',
			}))
			const host = document.createElement('div')
			document.body.appendChild(host)
			const app = createApp(Lightbox, {
				images,
				startIndex: links.indexOf(link),
				onClose: () => {
					app.unmount()
					host.remove()
				},
			})
			app.mount(host)
		})
	})
}
